<script setup lang="ts">
import { computed } from 'vue'
import { useNow } from '@vueuse/core'

import { useSidebarStore } from '../model/sidebar'

const UTC_DATE = new Intl.DateTimeFormat('en-US', {
  timeZone: 'UTC',
  month: 'long',
  day: 'numeric',
  year: 'numeric'
})

const pad = (value: number) => String(value).padStart(2, '0')

const serverTime = (now: Date) =>
  `Server Time ${pad(now.getUTCHours())}:${pad(now.getUTCMinutes())}:${pad(
    now.getUTCSeconds()
  )} | ${UTC_DATE.format(now)}`

const now = useNow({ interval: 1000 })
const timeString = computed(() => serverTime(now.value))

const sidebar = useSidebarStore()
</script>

<template>
  <div
    class="app-footer"
    :class="{ 'app-footer--sidebar-open': sidebar.opened }"
  >
    <p>{{ timeString }}</p>
  </div>
</template>

<style lang="scss" scoped>
.app-footer {
  height: 30px;
  width: 100%;
  text-align: center;
  background-color: var(--el-border-color-light);
  line-height: 1.5;
  position: fixed;
  z-index: 2000;
  bottom: 0;
  font-size: 10px;
}

.app-footer--sidebar-open {
  padding-right: var(--side-bar-width);
}
</style>
